import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { useMemo } from 'react';
import { BatteryPercentIcon } from '../../common/BatteryPercentIcon';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const BatteryPercentIconWidget = () => {
    const component = useMemo(() => (_jsxs("div", { style: { display: 'flex', gap: 8, flexDirection: 'column' }, children: [_jsx(Typography, { variant: "h6", children: "Horizontal variant" }), _jsx("div", { style: { width: 128, height: 48 }, children: _jsx(BatteryPercentIcon, { percentage: 84, variant: "horizontal", hideText: false }) }), _jsx(Typography, { variant: "h6", children: "Vertical variant" }), _jsx("div", { style: { width: 48, height: 96 }, children: _jsx(BatteryPercentIcon, { percentage: 16, variant: "vertical", hideText: true }) })] })), []);
    return {
        name: 'BatteryPercentIcon',
        category: 'common',
        component,
    };
};
